import { fetchUtkast, updateVinjett } from 'store/utkastSlice';

import { GranskningResursIndex, VinjettPutParam } from 'models';

import { bebyggelseApiRTK } from 'api/bebyggelseApiRTK';

const UTKAST_URL = `bebyggelseobjekt/utkast`;

export const dokumentationSlice = bebyggelseApiRTK.injectEndpoints({
  endpoints: (build) => ({
    getDokumentation: build.query<Array<GranskningResursIndex>, string>({
      query: (id) => ({
        url: `${UTKAST_URL}/${id}/dokumentation`,
        method: 'GET'
      }),
      providesTags: ['Dokumentation']
    }),
    deleteDokumentation: build.mutation<void, { utkastId: string; resursId: string; isVinjett: boolean }>({
      query: ({ utkastId, resursId }) => ({
        url: `${UTKAST_URL}/${utkastId}/dokumentation/${resursId}`,
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }),
      onQueryStarted: async ({ utkastId, resursId, isVinjett }, { dispatch, queryFulfilled }) => {
        await queryFulfilled;

        // Är det raderade dokumentet valt som vinjett hämtar vi om dokumentation och utkast för att låta api:et bestämma vad som ska vara vinjett.
        // Annars tar vi bort det manuellt ur cachen för att undvika omhämtning.
        if (isVinjett) {
          dispatch(dokumentationSlice.util.invalidateTags(['Dokumentation']));
          dispatch(fetchUtkast(utkastId));
        } else {
          dispatch(
            dokumentationSlice.util.updateQueryData('getDokumentation', utkastId, (draft) =>
              draft.filter((obj) => obj.resurs_id !== resursId)
            )
          );
        }
      }
    }),
    putVinjett: build.mutation<GranskningResursIndex, { utkastId: string; vinjettParam: VinjettPutParam }>({
      query: ({ utkastId, vinjettParam }) => ({
        url: `${UTKAST_URL}/${utkastId}/dokumentation/vinjett`,
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(vinjettParam)
      }),
      onQueryStarted: async ({ utkastId, vinjettParam }, { dispatch, queryFulfilled }) => {
        if (vinjettParam.arkivreferens_uri) {
          dispatch(updateVinjett(vinjettParam.arkivreferens_uri));
        }

        if (vinjettParam.resurs_id) {
          dispatch(updateVinjett(vinjettParam.resurs_id));
        }

        await queryFulfilled;

        // Sätt vinjett på dokument manuellt i cachen om det gick bra.
        dispatch(
          dokumentationSlice.util.updateQueryData('getDokumentation', utkastId, (draft) => {
            draft.forEach((d) => (d.vinjett = d.resurs_id === vinjettParam.resurs_id));
            return draft;
          })
        );
      }
    })
  })
});

export const { useGetDokumentationQuery, useDeleteDokumentationMutation, usePutVinjettMutation } = dokumentationSlice;
